import { render } from "./reserveMarkets.vue?vue&type=template&id=5b719ad4&scoped=true"
import script from "./reserveMarkets.vue?vue&type=script&lang=js"
export * from "./reserveMarkets.vue?vue&type=script&lang=js"

import "./reserveMarkets.vue?vue&type=style&index=0&id=5b719ad4&scoped=true&lang=css"
import "./reserveMarkets.vue?vue&type=style&index=1&id=5b719ad4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b719ad4"]])

export default __exports__